// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-details table tbody tr td[data-v-53cfea74]:first-child{font-weight:700}.profile-details .table td[data-v-53cfea74],.profile-details .table th[data-v-53cfea74]{padding:0;line-height:35px}", ""]);
// Exports
module.exports = exports;
